import PieChart from './PieChart'

export default PieChart


// WEBPACK FOOTER //
// ./src/components/PieChart/index.js